export function formatGoogleSignInError(error: unknown): string {
  const code = typeof error === 'object' && error !== null && 'code' in error
    ? String((error as { code?: string }).code)
    : '';

  if (code === 'auth/popup-closed-by-user') {
    return 'Sign-in was cancelled. You can try again when ready.';
  }
  if (code === 'auth/unauthorized-domain') {
    return 'This preview hostname is not authorized for Google Sign-In in Firebase Authentication. Ask an admin to add it to authorized domains.';
  }
  if (code === 'auth/network-request-failed') {
    return 'Network error while signing in. Check your connection and try again.';
  }
  if (code === 'auth/popup-blocked') {
    return 'Your browser blocked the sign-in popup. Allow popups for this site and try again.';
  }

  const message = error instanceof Error ? error.message : String(error ?? 'Unknown error');
  return message.trim() || 'Sign-in failed. Please try again.';
}

export function isSignInActionDisabled(loading: boolean, signingIn: boolean): boolean {
  return loading || signingIn;
}

export async function runGoogleSignIn(deps: {
  login: () => Promise<void>;
  signingIn: boolean;
  setSigningIn: (value: boolean) => void;
  setError: (message: string | null) => void;
}): Promise<void> {
  if (deps.signingIn) return;

  deps.setError(null);
  deps.setSigningIn(true);
  try {
    await deps.login();
  } catch (error) {
    deps.setError(formatGoogleSignInError(error));
  } finally {
    deps.setSigningIn(false);
  }
}
